

import Timer from '@/utils/timer'

export default {
    install: async (Vue) => {
    // Set libraries and utils.
        const listLibraries = {
            timer: Timer,
        }

    // Set previous list to vue prototipe for global use
        for (const library in listLibraries) {
            Vue.prototype[`$${library}`] = listLibraries[library]
        }
    },
}
